import ContactUsForm from "@resources/js/components/ContactUsForm";

if (document.querySelector('#form-feedback')) {

    const contactUsFormEl = document.querySelector('#form-feedback');

    const contactUsForm = new ContactUsForm(contactUsFormEl);

    const messageBlock = document.querySelector('.js-message');
    const messages = {
        success: `<p class="message message--success">
                <svg class="message__icon icon icon-check-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill-rule="nonzero" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zM8.268 14L4 9.85l1.494-1.453 2.774 2.698L13.506 6 15 7.453 8.268 14z"/>
                </svg>

                <span class="message__text">Your message sent</span>
            </p>`,
        error: `<p class="message message--error">
                <svg class="message__icon icon icon-sunset-alert-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 493.5 493.5" xml:space="preserve">
                    <path d="M492.4,143.7L350.3,1.3c-0.7-0.7-1.7-1.1-2.7-1.1L146.4,0c-1,0-2,0.4-2.7,1.1L1.4,143.2c-0.7,0.7-1.1,1.7-1.1,2.7L0,347.1  c0,1,0.4,2,1.1,2.7l142.1,142.3c0.7,0.7,1.7,1.2,2.7,1.2l201.1,0.2c1,0,2-0.4,2.7-1.2l142.4-142.1c0.7-0.7,1.1-1.7,1.1-2.7  l0.2-201.1C493.5,145.4,493.1,144.4,492.4,143.7z M262.2,428.1c-4.1,4.1-9.8,6.4-15.6,6.4c-5.8,0-11.5-2.3-15.6-6.4  c-4.1-4.1-6.3-9.8-6.3-15.7c0-5.8,2.5-11.5,6.5-15.6c4.2-4.1,10.3-6.5,15.8-6.5c5.7,0,11.3,2.4,15.4,6.5c4.1,4.1,6.4,9.8,6.4,15.6  C268.7,418.3,266.3,424,262.2,428.1z M268.7,324.1c0,12.1-9.9,22.1-22.1,22.1s-22.1-9.9-22.1-22.1l0.3-243C224.9,68.9,236,59,247,59  c5.9,0,11.3,2.3,15.5,6.5s6.4,9.7,6.4,15.6L268.7,324.1z"/>
                </svg>

                <span class="message__text">Your message was not delivered</span>
            </p>`,
        loading: null
    };

    const statusManager = {
        hide: () => {
            if(messageBlock.firstChild) messageBlock.removeChild(messageBlock.firstChild);
        },
        show: status => {
            statusManager.hide()
            messageBlock.insertAdjacentHTML('afterbegin', messages[status])
        }
    }

    contactUsForm.on('loading', () => {
        statusManager.show('loading')
    })

    contactUsForm.on('success', () => {
        statusManager.hide()
        statusManager.show('success')
        contactUsForm.resetForm()
        setTimeout(() => statusManager.hide(), 3000)
    })

    contactUsForm.on('error', () => {
        statusManager.hide()
        statusManager.show('error')
        setTimeout(() => statusManager.hide(), 3000)
    })


}
